module.exports = __webpack_public_path__ + "img/video.1cdb051c.png";